var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", [
    _vm.bullet.Name && _vm.bullet.Value
      ? _c("span", { staticClass: "articlenumber small text-muted" }, [
          _c("b", [_vm._v(_vm._s(_vm.bullet.Name))]),
          _vm._v(" "),
          _vm.bullet.url
            ? _c("span", [
                _c(
                  "a",
                  {
                    attrs: {
                      "data-toggle": "modal",
                      href: "#shippingscosts",
                      title: "Mehr Informationen"
                    },
                    on: {
                      click: function($event) {
                        return _vm.getCategoryDescription()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.bullet.Value))]
                )
              ])
            : _c("span", [_vm._v(_vm._s(_vm.bullet.Value))])
        ])
      : _vm._e(),
    _vm.bullet.Name && _vm.bullet.Value ? _c("br") : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }